import * as React from "react";
import { ConfirmationDialog } from "../Admin/common/ConfirmationDialog";

const ARCHIVE_MESSAGE =
  "This will archive the survey and hide it from the survey list. You can restore it later using the Archived filter.";

export interface ArchiveSurveyDialogProps {
  entityName: string;
  isOpen: boolean;
  isPending: boolean;
  close: () => void;
  confirm: () => void;
}

export function ArchiveSurveyDialog(props: ArchiveSurveyDialogProps) {
  const { entityName, isOpen, isPending, close, confirm } = props;

  return (
    <ConfirmationDialog
      entityType="Survey"
      entityName={entityName}
      titleAction="Archive"
      actionText="Archive"
      actioningText="Archiving..."
      icon="archive"
      message={ARCHIVE_MESSAGE}
      isOpen={isOpen}
      isPending={isPending}
      onClose={close}
      onConfirm={confirm}
    />
  );
}
